import React from "react";
import PropTypes from "prop-types";

import { useTranslation } from "react-i18next";

import { StyledButton } from "./TextButtonStyle";
import { Link } from "gatsby";

const TextButton = ({ value, hrefValue, headerBackground, darkColor, as }) => {
  const { t } = useTranslation();
  return (
    <>
      {as === "a" ? (
        <a href={hrefValue} aria-label={value} rel="noreferrer" target="_blank">
          <StyledButton darkColor={darkColor} headerBackground={headerBackground}>
            {t(value)}
          </StyledButton>
        </a>
      ) : (
        <Link to={hrefValue}>
          <StyledButton darkColor={darkColor} headerBackground={headerBackground}>
            {t(value)}
          </StyledButton>
        </Link>
      )}  
    </>
  );
};

TextButton.propTypes = {
  value: PropTypes.string,
  darkColor: PropTypes.bool,
  as: PropTypes.string
};
export default TextButton;
